<a (click)="openBetaTrialModal()" target="_blank" class="position bottom">
  <img [src]="advertimentImg" [alt]="advertimentImgAltText">
</a>